import { lazy } from 'react';
// import { default as ContactPrivateInfo } from './ContactPrivateInfo';
const ContactPrivateInfo = lazy(() => import('./ContactPrivateInfo'));  
export { ContactPrivateInfo };



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactPrivateInfo/components/index.js